import { AdSet } from '../../entities/ad-set';
import { Metadata } from '../../entities/metadata';
import type { ApplicationConfig } from '../../types';
import { uuidv4 } from '../../utils/uuid';
import { Injectable } from '../dependency-injection/decorators';

@Injectable()
export class ApplicationContext {
  private sessionId: string;
  private adSet: AdSet | null = null;
  private metadata: Metadata | null = null;
  private canRenderApplication: boolean = true;
  private readonly window: Window;
  private readonly applicationConfig: ApplicationConfig;

  public constructor (applicationConfig: ApplicationConfig, window: Window) {
    this.sessionId = uuidv4();
    this.applicationConfig = applicationConfig;
    this.window = window;
  }

  public getApplicationConfig (): ApplicationConfig {
    return this.applicationConfig;
  }

  public getStartTime (): number {
    return this.applicationConfig.startTime;
  }

  public getSessionId (): string {
    return this.sessionId;
  }

  public setSessionId (sessionId: string): void {
    this.sessionId = sessionId;
  }

  public getApplicationId (): string {
    return this.applicationConfig.id;
  }

  public isDebug (): boolean {
    return this.applicationConfig.debug;
  }

  public getVersion (): string {
    return this.applicationConfig.version;
  }

  public getWindow (): Window {
    return this.window;
  }

  public getAdSet (): AdSet | null {
    return this.adSet;
  }

  public setAdSet (adSet: AdSet | null): void {
    this.adSet = adSet;
  }

  public getMetadata (): Metadata | null {
    return this.metadata;
  }

  public setMetadata (metadata: Metadata): void {
    this.metadata = metadata;
  }

  public setCanRender (canRender: boolean): void {
    this.canRenderApplication = canRender;
  }

  public canRender (): boolean {
    return this.canRenderApplication;
  }
}
